import React from 'react';
import {IconMessageCircle,IconArrowRight} from './Icons';
import {BOOK_URL,EMAIL_US} from '../siteConfig';

function ClosingCta() {
  return (
    <section className="section" id="talk">
      <div className="dfy">
        <div>
          <span className="kicker">Not sure where to start?</span>
          <h2>Tell us what is slipping through the cracks.</h2>
          <p>
            Missed calls, slow replies, no-shows, unpaid invoices, too few reviews: on a free 30-minute call we will tell you what would help most, and what you can skip.
          </p>
        </div>
        <div className="dfy-cta">
          <a className="primary-button" href={BOOK_URL}>
            Book a free call <IconArrowRight />
          </a>
          <a className="text-button" href={EMAIL_US}>
            <IconMessageCircle /> Email us instead
          </a>
          <small className="reassurance">No pressure and no jargon.</small>
        </div>
      </div>
    </section>
  );
}

export default ClosingCta;
